export default "__VITE_PUBLIC_ASSET__77698f40__"